export default __webpack_public_path__ + "static/livre_blanc_compliance-cab2445814dd893239a6ee7e8282f92d.png";